import eventNames from './names';

export default {
	[eventNames.BEFORE_REQUEST]: {
		[eventNames.BEFORE_COUNTERS_REQUEST]: {},
		[eventNames.BEFORE_PRODUCTS_REQUEST]: {},
		[eventNames.BEFORE_MAP_REQUEST]: {},
		[eventNames.BEFORE_GEO_DATA_REQUEST]: {},
		[eventNames.BEFORE_START_DATES_REQUEST]: {},
		[eventNames.BEFORE_END_DATES_REQUEST]: {},
	},
	[eventNames.AFTER_REQUEST]: {
		[eventNames.AFTER_COUNTERS_REQUEST]: {},
		[eventNames.AFTER_PRODUCTS_REQUEST]: {},
		[eventNames.AFTER_MAP_REQUEST]: {},
		[eventNames.AFTER_GEO_DATA_REQUEST]: {},
		[eventNames.AFTER_START_DATES_REQUEST]: {},
		[eventNames.AFTER_END_DATES_REQUEST]: {},
	},
}